export function startSessionWatcher(timeoutMinutes = 120) {
  let timer;

  const logout = () => {
    localStorage.clear();
    window.location.replace("/login"); // важно: replace
  };

  const resetTimer = () => {
    clearTimeout(timer);
    timer = setTimeout(logout, timeoutMinutes * 60 * 1000);
  };

  const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

  events.forEach((event) => {
    window.addEventListener(event, resetTimer);
  });

  resetTimer();

  return () => {
    clearTimeout(timer);
    events.forEach((event) => {
      window.removeEventListener(event, resetTimer);
    });
  };
}